var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { switchProp } from 'styled-tools';
import * as Shared from '../../../ContentSystem.shared.styles';
import { CardTextSet as CardTextSetOriginal } from '../../TextSet/TextSet';
import { Container } from '../../../../ImageContent/ImageContent.styled';
export var CardTextSet = styled(CardTextSetOriginal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: flex-start;\n  width: 100%;\n  height: 100%;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  align-self: flex-start;\n  width: 100%;\n  height: 100%;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var horizontalTextAlignment = _a.horizontalTextAlignment;
    return horizontalTextAlignment ?
        switchProp('horizontalTextAlignment', {
            CENTER: "\n        align-items: center;\n        text-align: center;\n        ".concat(Shared.CTAGroup, " {\n          justify-content: center;\n        }\n        ").concat(Shared.Header, ", ").concat(Shared.SecondaryHeader, ", ").concat(Shared.Body, " {\n          margin-left: auto;\n          margin-right: auto;\n        }\n      "),
            RIGHT: "\n        align-items: flex-end;\n        ".concat(Shared.CTAGroup, " {\n          justify-content: end\n        }\n      "),
            LEFT: 'align-items: flex-start; text-align: left;'
        }) :
        'align-items: flex-start; text-align: left;';
}, function (_a) {
    var _b = _a.verticalTextPosition, verticalTextPosition = _b === void 0 ? 'TOP' : _b;
    if (verticalTextPosition === 'TOP') {
        return "\n        top: 0;\n      ";
    }
    if (verticalTextPosition === 'MIDDLE') {
        return "\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n      ";
    }
    if (verticalTextPosition === 'BOTTOM') {
        return "\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n      ";
    }
    if (verticalTextPosition === 'BELOW_IMAGE') {
        return "\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n      ";
    }
    if (verticalTextPosition === 'ABOVE_IMAGE') {
        return "\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        order: -1;\n      ";
    }
}, function (_a) {
    var verticalTextPosition = _a.verticalTextPosition, cardType = _a.cardType, hoverEffect = _a.hoverEffect;
    return hoverEffect === 'SHOW_CTA' &&
        verticalTextPosition === 'MIDDLE' &&
        (cardType === 'CONTENT_CARD_MEGA'
            ? 'transform: translateY(calc(-50% + 32px));'
            : cardType === 'CONTENT_CARD_MINI' || cardType === 'CONTENT_CARD_REGULAR'
                ? 'transform: translateY(calc(-50% + 24px));'
                : '');
});
export var CardContentWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n\n  ", " {\n    position: relative;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n\n  ", " {\n    position: relative;\n  }\n"])), Container);
export var CardTextSetContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: flex-start;\n  width: 100%;\n  height: 100%;\n  & > div {\n    flex-grow: 1;\n  }\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n  // Apply padding based on the card size\n  ", "\n"], ["\n  align-self: flex-start;\n  width: 100%;\n  height: 100%;\n  & > div {\n    flex-grow: 1;\n  }\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n  // Apply padding based on the card size\n  ", "\n"])), function (_a) {
    var flexGrow = _a.flexGrow, hasImage = _a.hasImage;
    return flexGrow &&
        "\n    ".concat(hasImage ? 'position: absolute;' : '', "\n    display: flex;\n    > div {\n      height: 100%;\n    }\n    flex-direction: column;\n    justify-content: space-between;\n  ");
}, function (_a) {
    var hasImage = _a.hasImage, verticalTextPosition = _a.verticalTextPosition;
    if (!hasImage) {
        switch (verticalTextPosition) {
            case 'MIDDLE':
                return 'align-content: center;';
            case 'BOTTOM':
                return 'align-content: flex-end;';
            default:
                return 'align-content: flex-start;';
        }
    }
    return '';
}, function (_a) {
    var verticalTextPosition = _a.verticalTextPosition;
    switch (verticalTextPosition) {
        case 'ABOVE_IMAGE':
            return 'padding-bottom: 16px;';
        default:
            return '';
    }
}, function (_a) {
    var hasImage = _a.hasImage;
    return !hasImage &&
        "\n      ".concat(CardTextSet, " {\n        transform: none;\n      }\n    ");
}, function (_a) {
    var _b = _a.responsiveSizes, responsiveSizes = _b === void 0 ? [{ screenSize: 'SMALL', textSize: 'MEGA' }] : _b, isTransparent = _a.isTransparent, internalSpace = _a.internalSpace, verticalTextPosition = _a.verticalTextPosition, hasImage = _a.hasImage, $styleQueryMode = _a.$styleQueryMode;
    return Shared.generateResponsivePadding({
        responsiveSizes: responsiveSizes,
        reponsiveInternalSpace: internalSpace,
        isTransparent: isTransparent,
        verticalTextPosition: verticalTextPosition,
        hasImage: hasImage,
        $styleQueryMode: $styleQueryMode
    });
});
var templateObject_1, templateObject_2, templateObject_3;
